// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Animations for the assistant icon */
.assistant-icon-container {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.assistant-icon-container.animating {
  animation: scale 0.8s ease;
}

.assistant-icon-pulse {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(22, 91, 251, 0.3);
  border-radius: 50%;
  animation: pulseAnimation 0.8s ease-out;
}

.gradient-flow {
  animation: colorFlow 2s ease-in-out;
}

@keyframes scale {
  0% {
    transform: scale(0.9);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes colorFlow {
  0% {
    opacity: 0.8;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.8;
  }
}

/* Blue button for "Use this brief" */
.use-brief-button {
  background-color: #165BFB;
  color: white;
  transition: all 0.3s ease;
}

.use-brief-button:hover {
  background-color: #0F4ED8;
  transform: translateY(-1px);
}

/* Translucent menu with blur effect */
.translucent-menu {
  background-color: rgba(255, 255, 255, 0.4);
  backdrop-filter: blur(12px);
  border-bottom: 1px solid rgba(237, 240, 245, 0.2);
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.02);
  will-change: transform;
}

/* Message bubble animations */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInFromRight {
  from {
    opacity: 0;
    transform: translateX(20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideInFromLeft {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes scaleIn {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* Apply animations to chat bubbles */
.message-user-bubble {
  animation: slideInFromRight 0.3s ease-out;
}

.message-ai-bubble {
  animation: slideInFromLeft 0.3s ease-out;
}

.message-help-bubble {
  animation: slideInFromLeft 0.3s ease-out;
}

/* Suggestion button animations */
.suggestion-button {
  animation: scaleIn 0.2s ease-out;
  transition: transform 0.2s ease, border-color 0.2s ease;
}

.suggestion-button:hover {
  transform: translateY(-2px) scale(1.02);
  border-color: #165BFB;
}

/* Completion buttons animations */
.completion-button-primary {
  transition: all 0.25s ease;
  box-shadow: 0px 4px 10px rgba(22, 91, 251, 0.15);
}

.completion-button-primary:hover {
  transform: translateY(-2px) scale(1.03);
  box-shadow: 0px 6px 15px rgba(22, 91, 251, 0.25);
  background-color: #0F4ED8;
}

.completion-button-primary:active {
  transform: scale(0.97);
  box-shadow: 0px 2px 5px rgba(22, 91, 251, 0.2);
}

.completion-button-secondary {
  transition: all 0.25s ease;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.05);
}

.completion-button-secondary:hover {
  transform: translateY(-2px) scale(1.03);
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.08);
  background-color: #f8f9fc;
}

.completion-button-secondary:active {
  transform: scale(0.97);
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.03);
}

/* Send button animations */
.send-button {
  transition: all 0.3s ease;
}

.send-button:hover {
  transform: scale(1.03);
}

.send-button:active {
  transform: scale(0.95);
}

.send-button-press {
  animation: sendPress 0.4s ease;
}

@keyframes sendPress {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.92);
  }
  100% {
    transform: scale(1);
  }
}

/* Chat container animations */
.chat-container-appear {
  animation: fadeIn 0.8s ease-out;
}

/* Help button animations */
.help-button {
  transition: all 0.2s ease;
}

.help-button:hover {
  transform: translateY(-2px);
}

/* Skip question button animations */
.skip-button {
  transition: all 0.2s ease;
}

.skip-button:hover {
  transform: translateX(2px);
}

/* Context menu animations */
.context-menu-appear {
  animation: contextMenuAppear 0.2s ease-out;
}

@keyframes contextMenuAppear {
  from {
    opacity: 0;
    transform: translateY(-5px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* Edit modal animations */
.edit-modal-backdrop {
  animation: backdropFadeIn 0.2s ease-out;
}

.edit-modal {
  animation: modalScaleIn 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

@keyframes backdropFadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes modalScaleIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* Brief field deletion animation */
.brief-field-delete {
  animation: briefFieldDelete 0.3s ease-out;
}

@keyframes briefFieldDelete {
  from {
    opacity: 1;
    transform: translateX(0);
  }
  to {
    opacity: 0;
    transform: translateX(20px);
  }
}

/* Brief field edit animation */
.brief-field-edit {
  animation: briefFieldEdit 0.3s ease-out;
}

@keyframes briefFieldEdit {
  0% {
    background-color: rgba(22, 91, 251, 0.1);
  }
  100% {
    background-color: transparent;
  }
}

/* Context menu option hover animation */
.context-menu-option {
  transition: all 0.15s ease;
}

.context-menu-option:hover {
  transform: translateX(2px);
  background-color: rgba(22, 91, 251, 0.05);
}

/* Chat message boundary and input area styles */
.chat-message-boundary {
  position: relative;
}

.chat-input-area {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(to bottom, transparent, var(--background) 40%);
  padding-top: 40px;
  pointer-events: none;
  z-index: 10;
}

.chat-input-area > * {
  pointer-events: auto;
}

/* Message boundary fade effect */
.message-boundary-fade {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100px;
  background: linear-gradient(to top, var(--background), transparent);
  pointer-events: none;
}

/* Add spinner animation styles */
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.animate-spin {
  animation: spin 1s linear infinite;
}

/* Pulse animation for the spinner background */
@keyframes pulse {
  0% { transform: scale(1); opacity: 0.7; }
  50% { transform: scale(1.05); opacity: 0.9; }
  100% { transform: scale(1); opacity: 0.7; }
}

.animate-pulse {
  animation: pulse 2s ease-in-out infinite;
}

/* Loading indicator animations */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.loading-indicator-appear {
  animation: fadeInUp 0.3s ease-out;
}
`, "",{"version":3,"sources":["webpack://./src/styles/animations.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA,qCAAqC;AACrC;EACE,yBAAyB;EACzB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,sCAAsC;AACtC;EACE,0CAA0C;EAE1C,2BAA2B;EAC3B,iDAAiD;EACjD,0CAA0C;EAC1C,sBAAsB;AACxB;;AAEA,8BAA8B;AAC9B;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA,qCAAqC;AACrC;EACE,yCAAyC;AAC3C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,iCAAiC;AACjC;EACE,gCAAgC;EAChC,uDAAuD;AACzD;;AAEA;EACE,uCAAuC;EACvC,qBAAqB;AACvB;;AAEA,kCAAkC;AAClC;EACE,0BAA0B;EAC1B,gDAAgD;AAClD;;AAEA;EACE,uCAAuC;EACvC,gDAAgD;EAChD,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,0BAA0B;EAC1B,2CAA2C;AAC7C;;AAEA;EACE,uCAAuC;EACvC,4CAA4C;EAC5C,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA,2BAA2B;AAC3B;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA,8BAA8B;AAC9B;EACE,+BAA+B;AACjC;;AAEA,2BAA2B;AAC3B;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,oCAAoC;AACpC;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,4BAA4B;AAC5B;EACE,0CAA0C;AAC5C;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA,0BAA0B;AAC1B;EACE,uCAAuC;AACzC;;AAEA;EACE,oEAAoE;AACtE;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA,mCAAmC;AACnC;EACE,yCAAyC;AAC3C;;AAEA;EACE;IACE,UAAU;IACV,wBAAwB;EAC1B;EACA;IACE,UAAU;IACV,2BAA2B;EAC7B;AACF;;AAEA,+BAA+B;AAC/B;EACE,uCAAuC;AACzC;;AAEA;EACE;IACE,wCAAwC;EAC1C;EACA;IACE,6BAA6B;EAC/B;AACF;;AAEA,wCAAwC;AACxC;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA,gDAAgD;AAChD;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,0EAA0E;EAC1E,iBAAiB;EACjB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,mEAAmE;EACnE,oBAAoB;AACtB;;AAEA,iCAAiC;AACjC;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA,+CAA+C;AAC/C;EACE,KAAK,mBAAmB,EAAE,YAAY,EAAE;EACxC,MAAM,sBAAsB,EAAE,YAAY,EAAE;EAC5C,OAAO,mBAAmB,EAAE,YAAY,EAAE;AAC5C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,iCAAiC;AACjC;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,iCAAiC;AACnC","sourcesContent":["/* Animations for the assistant icon */\n.assistant-icon-container {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.assistant-icon-container.animating {\n  animation: scale 0.8s ease;\n}\n\n.assistant-icon-pulse {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  background: rgba(22, 91, 251, 0.3);\n  border-radius: 50%;\n  animation: pulseAnimation 0.8s ease-out;\n}\n\n.gradient-flow {\n  animation: colorFlow 2s ease-in-out;\n}\n\n@keyframes scale {\n  0% {\n    transform: scale(0.9);\n  }\n  50% {\n    transform: scale(1.1);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n@keyframes colorFlow {\n  0% {\n    opacity: 0.8;\n  }\n  50% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0.8;\n  }\n}\n\n/* Blue button for \"Use this brief\" */\n.use-brief-button {\n  background-color: #165BFB;\n  color: white;\n  transition: all 0.3s ease;\n}\n\n.use-brief-button:hover {\n  background-color: #0F4ED8;\n  transform: translateY(-1px);\n}\n\n/* Translucent menu with blur effect */\n.translucent-menu {\n  background-color: rgba(255, 255, 255, 0.4);\n  -webkit-backdrop-filter: blur(12px);\n  backdrop-filter: blur(12px);\n  border-bottom: 1px solid rgba(237, 240, 245, 0.2);\n  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.02);\n  will-change: transform;\n}\n\n/* Message bubble animations */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes slideInFromRight {\n  from {\n    opacity: 0;\n    transform: translateX(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes slideInFromLeft {\n  from {\n    opacity: 0;\n    transform: translateX(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes scaleIn {\n  from {\n    opacity: 0;\n    transform: scale(0.8);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n/* Apply animations to chat bubbles */\n.message-user-bubble {\n  animation: slideInFromRight 0.3s ease-out;\n}\n\n.message-ai-bubble {\n  animation: slideInFromLeft 0.3s ease-out;\n}\n\n.message-help-bubble {\n  animation: slideInFromLeft 0.3s ease-out;\n}\n\n/* Suggestion button animations */\n.suggestion-button {\n  animation: scaleIn 0.2s ease-out;\n  transition: transform 0.2s ease, border-color 0.2s ease;\n}\n\n.suggestion-button:hover {\n  transform: translateY(-2px) scale(1.02);\n  border-color: #165BFB;\n}\n\n/* Completion buttons animations */\n.completion-button-primary {\n  transition: all 0.25s ease;\n  box-shadow: 0px 4px 10px rgba(22, 91, 251, 0.15);\n}\n\n.completion-button-primary:hover {\n  transform: translateY(-2px) scale(1.03);\n  box-shadow: 0px 6px 15px rgba(22, 91, 251, 0.25);\n  background-color: #0F4ED8;\n}\n\n.completion-button-primary:active {\n  transform: scale(0.97);\n  box-shadow: 0px 2px 5px rgba(22, 91, 251, 0.2);\n}\n\n.completion-button-secondary {\n  transition: all 0.25s ease;\n  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.05);\n}\n\n.completion-button-secondary:hover {\n  transform: translateY(-2px) scale(1.03);\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.08);\n  background-color: #f8f9fc;\n}\n\n.completion-button-secondary:active {\n  transform: scale(0.97);\n  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.03);\n}\n\n/* Send button animations */\n.send-button {\n  transition: all 0.3s ease;\n}\n\n.send-button:hover {\n  transform: scale(1.03);\n}\n\n.send-button:active {\n  transform: scale(0.95);\n}\n\n.send-button-press {\n  animation: sendPress 0.4s ease;\n}\n\n@keyframes sendPress {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(0.92);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n/* Chat container animations */\n.chat-container-appear {\n  animation: fadeIn 0.8s ease-out;\n}\n\n/* Help button animations */\n.help-button {\n  transition: all 0.2s ease;\n}\n\n.help-button:hover {\n  transform: translateY(-2px);\n}\n\n/* Skip question button animations */\n.skip-button {\n  transition: all 0.2s ease;\n}\n\n.skip-button:hover {\n  transform: translateX(2px);\n}\n\n/* Context menu animations */\n.context-menu-appear {\n  animation: contextMenuAppear 0.2s ease-out;\n}\n\n@keyframes contextMenuAppear {\n  from {\n    opacity: 0;\n    transform: translateY(-5px) scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n/* Edit modal animations */\n.edit-modal-backdrop {\n  animation: backdropFadeIn 0.2s ease-out;\n}\n\n.edit-modal {\n  animation: modalScaleIn 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n}\n\n@keyframes backdropFadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes modalScaleIn {\n  from {\n    opacity: 0;\n    transform: scale(0.9);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n/* Brief field deletion animation */\n.brief-field-delete {\n  animation: briefFieldDelete 0.3s ease-out;\n}\n\n@keyframes briefFieldDelete {\n  from {\n    opacity: 1;\n    transform: translateX(0);\n  }\n  to {\n    opacity: 0;\n    transform: translateX(20px);\n  }\n}\n\n/* Brief field edit animation */\n.brief-field-edit {\n  animation: briefFieldEdit 0.3s ease-out;\n}\n\n@keyframes briefFieldEdit {\n  0% {\n    background-color: rgba(22, 91, 251, 0.1);\n  }\n  100% {\n    background-color: transparent;\n  }\n}\n\n/* Context menu option hover animation */\n.context-menu-option {\n  transition: all 0.15s ease;\n}\n\n.context-menu-option:hover {\n  transform: translateX(2px);\n  background-color: rgba(22, 91, 251, 0.05);\n}\n\n/* Chat message boundary and input area styles */\n.chat-message-boundary {\n  position: relative;\n}\n\n.chat-input-area {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: linear-gradient(to bottom, transparent, var(--background) 40%);\n  padding-top: 40px;\n  pointer-events: none;\n  z-index: 10;\n}\n\n.chat-input-area > * {\n  pointer-events: auto;\n}\n\n/* Message boundary fade effect */\n.message-boundary-fade {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 100px;\n  background: linear-gradient(to top, var(--background), transparent);\n  pointer-events: none;\n}\n\n/* Add spinner animation styles */\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.animate-spin {\n  animation: spin 1s linear infinite;\n}\n\n/* Pulse animation for the spinner background */\n@keyframes pulse {\n  0% { transform: scale(1); opacity: 0.7; }\n  50% { transform: scale(1.05); opacity: 0.9; }\n  100% { transform: scale(1); opacity: 0.7; }\n}\n\n.animate-pulse {\n  animation: pulse 2s ease-in-out infinite;\n}\n\n/* Loading indicator animations */\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.loading-indicator-appear {\n  animation: fadeInUp 0.3s ease-out;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
